module.exports = __webpack_public_path__ + "static/media/4years.1145c630.ipynb";